import { render, staticRenderFns } from "./ControlsPanel.vue?vue&type=template&id=b4f54526&lang=pug&"
import script from "./ControlsPanel.vue?vue&type=script&lang=js&"
export * from "./ControlsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports